import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

export const propertyVmGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const api = inject(ApiService);
  const router = inject(Router);
  const next = String(route.data['vmNext'] ?? 'reservations');
  try {
    const ctx = await firstValueFrom(
      api.get<{
        activeProperty: { code: string } | null;
        vmSession: { active: boolean; propertyId: string | null };
      }>('/context/property'),
    );
    const active = ctx.activeProperty;
    const vm = ctx.vmSession;
    if (active?.code && vm.active && String(vm.propertyId ?? '').trim().toLowerCase() === active.code.toLowerCase()) {
      return true;
    }
    if (!active?.code) {
      await router.navigateByUrl('/properties');
      return false;
    }
    await router.navigateByUrl(`/import/vm-auth?next=${encodeURIComponent(next)}`);
    return false;
  } catch {
    await router.navigateByUrl('/properties');
    return false;
  }
};
